import { supabase } from './supabase';
import { v4 as uuidv4 } from 'uuid';

export async function uploadMediaFile(file: File, type: 'image' | 'audio' | 'document'): Promise<string> {
  try {
    // First check if bucket exists
    const { data: buckets, error: bucketError } = await supabase
      .storage
      .listBuckets();

    if (bucketError) {
      throw new Error(`Error checking storage buckets: ${bucketError.message}`);
    }

    const bucketExists = buckets.some(bucket => bucket.name === 'chatbot-media');
    if (!bucketExists) {
      throw new Error('Storage bucket "chatbot-media" not found. Please ensure the storage bucket is properly configured.');
    }

    // Generate unique file name
    const fileExt = file.name.split('.').pop();
    const fileName = `${uuidv4()}.${fileExt}`;
    const filePath = `media/${type}/${fileName}`;

    // Upload file to Supabase Storage
    const { data, error } = await supabase.storage
      .from('chatbot-media')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (error) {
      console.error('Error uploading file:', error);
      throw new Error(`Error uploading file: ${error.message}`);
    }

    if (!data) {
      throw new Error('No data returned from file upload');
    }

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('chatbot-media')
      .getPublicUrl(filePath);

    if (!publicUrl) {
      throw new Error('Failed to get public URL for uploaded file');
    }

    return publicUrl;
  } catch (error) {
    console.error('Error in uploadMediaFile:', error);
    throw error instanceof Error ? error : new Error('An unknown error occurred while uploading the file');
  }
}